export default {
  formId: '',
  workData: [],
  educationData: []
};
